<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">By</span> L.J. L<span class="t3">A</span>B<span class="t3">ARTHE</span></p>
<p class="p0"><span class="t1">The Body on the Beach</span></p>
<p class="p0"><span class="t1">City of Jade</span></p>
<p class="p0"><span class="t1">Long Road Back</span></p>
<p class="p0"><span class="t1">Piece Us Back Together (Multiple Author Anthology)</span></p>
<p class="p0"><span class="t1">Swimming with Elephants</span></p>
<p class="p0"><span class="t1">Ties that Bind</span></p>
<p class="p0"><span class="t1">Under the Southern Cross (Dreamspinner Anthology)</span></p>
<p class="p2"><span class="t1">Waiting for the Moon and You</span></p>
<p class="p0"><span class="t4">A</span><span class="t5">RCHANGEL</span> <span class="t4">C</span><span class="t5">HRONICLES</span></p>
<p class="p0"><span class="t1">No Quarter</span></p>
<p class="p0"><span class="t1">No Surrender, No Retreat</span></p>
<p class="p0"><span class="t1">No Shadows Fall</span></p>
<p class="p0"><span class="t1">The Wind-up Forest</span></p>
<p class="p0"><span class="t1">The Crystal Lake</span></p>
<p class="p0"><span class="t1">The Bone Cup</span></p>
<p class="p0"><span class="t1">A Shot in the Dark</span></p>
<p class="p0"><span class="t1">A Fire in the Heart</span></p>
<p class="p3"><span class="t1">Published by</span> D<span class="t3">REAMSPINNER</span> P<span class="t3">RESS</span></p>
<p class="p0"><span class="t1">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?ef3ac82c